import BaseService from "../BaseService";
import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const apiEndpoint = API_BASE_URL_ENV() + "/site/compound";
const apiCompoundSpecificationsEndpoint = API_BASE_URL_ENV() + "/site/compound-specifications/";
const apiSendCilEndpoint = API_BASE_URL_ENV() + "/website/user/send-compound-message";

export default class extends BaseService {
    constructor() {
        super(apiEndpoint);
    }
    getCompoundSpecifications = (id)=>{
        return http.get(`${apiCompoundSpecificationsEndpoint+id}`, )
    }
    sendCil = (data)=>{
        return http.post(apiSendCilEndpoint, data);
    }
}
